/**
 * Inject in each route a regexExp to handle with queryString
 * @param {array<object>} routes { path: '', component: 'pg-home'}
 */
export const resolveRoutes = (routes) => {
    return routes.map(r => {
        if (r.path === '') r.path = '/'

        const paths = r.path.split('/')
        const last = paths[paths.length - 1]
        const qExp = '(/?[?][^?/]*)?'

        if (last.includes(':')) {
            if (last.includes('(')) {
                r.path = r.path + qExp
            } else if (last[last.length - 1] === '?') {
                // remove the '?' from the optional route param, to add the regex
                r.path = `${r.path.slice(0, -1)}([^?/]*)?${qExp}`
            } else {
                r.path = `${r.path}([^?/]*)${qExp}`
            }
        } else {
            r.path = r.path + qExp
        }

        return r
    })
}
